export default "__VITE_ASSET__NC07BUyI__"